/* Small accessibility and validation fixes for the installed Shrine components. */
(() => {
  function gloveField(form) {
    // Shopify has an input named "id", which shadows HTMLFormElement.id.
    const formId = form?.getAttribute?.('id');
    if (!formId || !formId.startsWith('product-form-')) return null;
    const sectionId = formId.slice('product-form-'.length);
    return Array.from(document.querySelectorAll('custom-product-field')).find(field =>
      field.dataset.section === sectionId &&
      field.dataset.name === 'Free gloves size' &&
      field.dataset.required === 'true'
    );
  }

  function validateGloves(form) {
    const field = gloveField(form);
    if (!field || field.querySelector('input[type="radio"]:checked')) return true;
    field.classList.add('bb-size-required');
    field.setAttribute('aria-invalid', 'true');
    field.querySelector('.input-error-msg')?.setAttribute('role', 'alert');
    field.scrollIntoView({block: 'center', behavior: 'auto'});
    field.querySelector('input[type="radio"]')?.focus({preventScroll: true});
    return false;
  }

  // Capture before Shrine's AJAX handlers. This also covers its featured-product form.
  document.addEventListener('click', event => {
    const button = event.target.closest?.('.product-form__submit');
    if (!button) return;
    const form = button.form || button.closest('form');
    if (!validateGloves(form)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('submit', event => {
    if (!validateGloves(event.target)) {
      event.preventDefault();
      event.stopImmediatePropagation();
    }
  }, true);

  document.addEventListener('change', event => {
    const field = event.target.closest?.('custom-product-field');
    if (field?.dataset.name === 'Free gloves size') {
      field.classList.remove('bb-size-required');
      field.removeAttribute('aria-invalid');
    }
  });

  function labelFields(root = document) {
    root.querySelectorAll('custom-product-field[data-name="Free gloves size"]').forEach(field => {
      const group = field.querySelector('.product-form__input');
      const label = field.querySelector('.form__label');
      if (!group || !label) return;
      label.id = field.id + '-label';
      group.setAttribute('role', 'radiogroup');
      group.setAttribute('aria-labelledby', label.id);
      group.setAttribute('aria-required', 'true');
    });
  }
  labelFields();
  document.addEventListener('shopify:section:load', event => labelFields(event.target));
})();
